<template>
  <div>
    <b-tabs pills card>
      <b-tab :title="$t('Group settings')" active>
        <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

        <basic-table
            v-if="rentsoftSettings"
            :items="rentsoftSettings"
            :fields="fields"
            @ClickOnDeleteButton="ClickOnDeleteButton"
            @ClickOnEditButton="editItem"
            :filter="filter"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            isDelete="true"
            isEdit="true"/>
        <table-manager-bottom
            :totalRows="totalRows" :perPage="perPage"
            v-model="currentPage"/>
      </b-tab>
      <b-tab :title="$t('Parametrs')" >
        <b-form-group v-if="isEnabledRentsoft" label-align="left" :label="$t(isEnabledRentsoft.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox size="lg" @change="changeIsEnabled" switch class="mt-2" v-model="isEnabledRentsoft.raw_values[0].value" unchecked-value="0" value="1"/>
        </b-form-group>
        <b-form-group v-if="rentsoftIsAidInsteadOfUID" label-align="left" :label="$t(rentsoftIsAidInsteadOfUID.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox size="lg" @change="changeIsAidInsteadOfUID" switch class="mt-2" v-model="rentsoftIsAidInsteadOfUID.raw_values[0].value" unchecked-value="0" value="1"/>
        </b-form-group>
        <b-form-group label-align="left" v-if="rentsoftDomain" :label="$t(rentsoftDomain.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input @update="changeRentsoftDomain" type="text" v-model="rentsoftDomain.raw_values[0].value"/>
        </b-form-group>
        <b-form-group label-align="left" v-if="rentsoftSecret" :label="$t(rentsoftSecret.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input @update="changeRentsoftSecret" type="text" v-model="rentsoftSecret.raw_values[0].value"/>
        </b-form-group>
        <b-form-group label-align="left" v-if="rentsoftAPIKey" :label="$t(rentsoftAPIKey.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input @update="changeRentsoftAPIKey" type="text" v-model="rentsoftAPIKey.raw_values[0].value"/>
        </b-form-group>
      </b-tab>
    </b-tabs>
    <editModal :editItem="selectedRentsoftSetting"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'accounting_period_id',
          label: this.$i18n.t('Accounting period'),
          sortable: true,
          formatter: (val, key, item) => {
            for (let el of this.accountingPeriods) {
              if (val === el.value) {
                return el.text
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedRentsoftSetting: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal
  },
  methods: {
    changeIsEnabled (value) {
      this.ChangeSystemSetting(value, this.isEnabledRentsoft)
    },
    changeIsAidInsteadOfUID (value) {
      this.ChangeSystemSetting(value, this.rentsoftIsAidInsteadOfUID)
    },
    changeRentsoftDomain (value) {
      this.ChangeSystemSetting(value, this.rentsoftDomain)
    },
    changeRentsoftSecret (value) {
      this.ChangeSystemSetting(value, this.rentsoftSecret)
    },
    changeRentsoftAPIKey (value) {
      this.ChangeSystemSetting(value, this.rentsoftAPIKey)
    },
    ChangeSystemSetting (value, setting) {
      let tmp = JSON.parse(JSON.stringify(setting))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(value)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 16, object_id: 0})
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Rentsoft settings"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_RENTSOFT_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_RENTSOFT_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedRentsoftSetting = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditRentsoftSetting', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedRentsoftSetting = {
        id: 0,
        group_id: 0,
        accounting_period_id: 0,
        is_post_paid: 0,
        is_juridical: 0,
        time_shift: 3,
        is_enabled: 1,
        tariffs: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditRentsoftSetting', '#btnShow')
    }
  },
  computed: {
    rentsoftSettings () {
      let tmp = JSON.parse(JSON.stringify(this.$store.getters['Settings/RENTSOFT_SETTINGS']))
      for (let el of tmp) {
        let color = el.is_enabled ? 'success' : 'danger'
        el._cellVariants = {id: color}
      }
      return tmp
    },
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    services () {
      return this.$store.getters['Tariffing/SERVICES']
    },
    templateServices () {
      let templateServices = this.services
      return templateServices.filter(function (value) {
        return value.parent_id !== 0 && value.tariff_id === 0
      })
    },
    accountingPeriods () {
      let res = []
      for (let el of this.$store.getters['Tariffing/ACCOUNTING_PERIODS']) {
        if (el.id === 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        let accPeriodName = ''
        switch (el.periodic_type) {
          case 1:
            accPeriodName = this.$i18n.t('Daily')
            break
          case 2:
            accPeriodName = this.$i18n.t('Weekly')
            break
          case 3:
            accPeriodName = this.$i18n.t('Monthly')
            break
          case 4:
            accPeriodName = this.$i18n.t('Quarterly')
            break
          case 5:
            accPeriodName = this.$i18n.t('Annual')
            break
          default:
            accPeriodName = this.$i18n.t('CustomDuration')
            break
        }

        newEl.text = el.id + ' (' + this.$root.getMomentWithTZDelta(Number(el.begin)).format('DD-MM-YYYY') + '-' + this.$root.getMomentWithTZDelta(Number(el.end)).format('DD-MM-YYYY') + ') ' + accPeriodName
        res.push(newEl)
      }
      return res
    },
    tariffs () {
      let res = []
      res.push({value: 0, text: this.$t('Disabled')})
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        if (el.id === 0) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      return res
    },
    registrySettings () {
      return JSON.parse(JSON.stringify(this.$store.getters['Settings/REGISTRY_SETTINGS']))
    },
    isEnabledRentsoft () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'rentsoft_is_enabled'
      })
      return tmp.length ? tmp[0] : null
    },
    rentsoftDomain () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'rentsoft_domain'
      })
      return tmp.length ? tmp[0] : null
    },
    rentsoftSecret () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'rentsoft_secret'
      })
      return tmp.length ? tmp[0] : null
    },
    rentsoftAPIKey () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'rentsoft_api_key'
      })
      return tmp.length ? tmp[0] : null
    },
    rentsoftIsAidInsteadOfUID () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'rentsoft_is_aid_instead_of_uid'
      })
      return tmp.length ? tmp[0] : null
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Settings/GET_RENTSOFT_SETTINGS')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_ACCOUNTING_PERIODS')
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 16, object_id: 0})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/rentsoft/main.vue